import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { Box, Button, Container, Grid, Stack, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import ContactUsModal from "../../layout/ContactUsModal";
import PlansCard from "../PlansCard";
import SectionHeading from "../shared/SectionHeading";
import { designTokens } from "../../../theme/designTokens";
import { clmFeatures } from "../../../theme/homeContent";

const { colors, borderRadius } = designTokens;

const ContractManagementSection = () => {
  const [showModal, setShowModal] = React.useState(false);
  const navigate = useNavigate();

  return (
    <Box sx={{ py: designTokens.spacing.sectionPy, backgroundColor: colors.background }}>
      <Container maxWidth={designTokens.spacing.containerMax}>
        <SectionHeading
          label="S-CLM PRODUCT"
          title="Sundeus CLM"
          highlight="(Contract Management Solution)"
          subtitle={`"S-CLM" is a Google cloud based contract management solution. It is a configurable product with top of the class technology basket. It's armed with predictive analysis capabilities using Artificial Intelligence principles. Be it your sales team, legal team,procurement team or human resources team with frequently changing government norms, narrow sales margins & cut throat competition S-CLM will keep your unwanted costs at lowest & help you streamline your contracting processes`}
        />

        <Typography
          variant="h4"
          sx={{ fontWeight: 700, textAlign: "center", mb: 4, color: colors.textPrimary }}
        >
          Features
        </Typography>

        <Grid container spacing={2} sx={{ mb: 6 }}>
          {clmFeatures.map((feature) => (
            <Grid item xs={12} md={6} key={feature}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  backgroundColor: colors.featureBg,
                  borderRadius: borderRadius.md,
                  px: 3,
                  py: 2,
                  minHeight: 74,
                }}
              >
                <Box
                  sx={{
                    width: 42,
                    height: 36,
                    backgroundColor: colors.primary,
                    borderRadius: borderRadius.sm,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                  }}
                >
                  <CheckCircleOutlineIcon sx={{ color: colors.white, fontSize: 20 }} />
                </Box>
                <Typography variant="body1" sx={{ fontWeight: 500, color: colors.textPrimary }}>
                  {feature}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>

        <PlansCard embedded />

        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          justifyContent="center"
          sx={{ mt: 6 }}
        >
          <ContactUsModal show={showModal} handleClose={() => setShowModal(false)} />
          <Button
            variant="contained"
            size="large"
            onClick={() => setShowModal(true)}
            sx={{ px: 5, py: 1.25, minWidth: 198, letterSpacing: 1 }}
          >
            Request a Demo
          </Button>
          <Button
            variant="outlined"
            size="large"
            onClick={() => navigate("/contract-management")}
            sx={{
              px: 5,
              py: 1.25,
              minWidth: 198,
              letterSpacing: 1,
              borderWidth: 2,
              borderColor: colors.primary,
              color: colors.primary,
              "&:hover": { borderWidth: 2 },
            }}
          >
            Learn more
          </Button>
        </Stack>
      </Container>
    </Box>
  );
};

export default ContractManagementSection;
